
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "BlockContent": [
      "BlockContentBasic"
    ],
    "Comment": [
      "CommentComment"
    ],
    "ContainerWidget": [
      "ContainerWidgetMain",
      "ContainerWidgetSidebar"
    ],
    "Entity": [
      "ApqQueryMap",
      "Author",
      "BlockContentBasic",
      "CbzLink",
      "CommentComment",
      "ContactPerson",
      "ContainerWidgetMain",
      "ContainerWidgetSidebar",
      "ContentModerationState",
      "Employee",
      "EmployeePosition",
      "EntityEmbedFakeEntity",
      "File",
      "InfoBox",
      "Linkcheckerlink",
      "MediaAudio",
      "MediaCbzDocument",
      "MediaDocument",
      "MediaImage",
      "MediaRemoteVideo",
      "MediaToccoDocument",
      "MediaVideo",
      "MenuLinkContentAccount",
      "MenuLinkContentAdmin",
      "MenuLinkContentComplianceMenu",
      "MenuLinkContentFooter",
      "MenuLinkContentMain",
      "MenuLinkContentMetaMenu",
      "MenuLinkContentTools",
      "NodeCbzLandingPage",
      "NodeEvent",
      "NodeLandingPage",
      "NodeNews",
      "NodeOpenJob",
      "NodePage",
      "NodePracticas",
      "NodeProtectedPage",
      "OverlayElement",
      "ParagraphAccordion",
      "ParagraphAccordionItem",
      "ParagraphAnchor",
      "ParagraphAnchors",
      "ParagraphAuthorSidebar",
      "ParagraphCarousel",
      "ParagraphCarouselItem",
      "ParagraphCbzAccordion",
      "ParagraphCbzAccordionContentItem",
      "ParagraphCbzAccordionItem",
      "ParagraphCbzDownloads",
      "ParagraphCbzLinkItem",
      "ParagraphCbzLinks",
      "ParagraphCbzListing",
      "ParagraphCbzNewContent",
      "ParagraphCbzNewsletter",
      "ParagraphContact",
      "ParagraphContactAccordionItem",
      "ParagraphContactPerson",
      "ParagraphContainerWidgetMain",
      "ParagraphContainerWidgetSidebar",
      "ParagraphCourseListing",
      "ParagraphCourseTeaser",
      "ParagraphCtaSidebar",
      "ParagraphDownloads",
      "ParagraphELearningListing",
      "ParagraphEducationOfferingItem",
      "ParagraphEducationOverview",
      "ParagraphEducationOverviewItem",
      "ParagraphEducationOverviewTeaserItem",
      "ParagraphEventListing",
      "ParagraphEventRegistration",
      "ParagraphEventTeasers",
      "ParagraphFeaturedNewsPosts",
      "ParagraphForm",
      "ParagraphFullHtmlText",
      "ParagraphHeading",
      "ParagraphHero",
      "ParagraphHeroHomepage",
      "ParagraphHeroItem",
      "ParagraphHotspotGraphic",
      "ParagraphHotspotItem",
      "ParagraphIconSectionItem",
      "ParagraphIframe",
      "ParagraphImage",
      "ParagraphInfoBox",
      "ParagraphInfoItems",
      "ParagraphIntrotext",
      "ParagraphJsScripts",
      "ParagraphLabelValueContent",
      "ParagraphLabelValueItem",
      "ParagraphLabelValueSidebar",
      "ParagraphLargeLinklist",
      "ParagraphLargeLinklistItem",
      "ParagraphLatestEducationOfferings",
      "ParagraphLegendItem",
      "ParagraphLinklist",
      "ParagraphListing",
      "ParagraphLogoSidebar",
      "ParagraphMap",
      "ParagraphMegaTeaser",
      "ParagraphMegaTeaserItem",
      "ParagraphOpenJobContactItem",
      "ParagraphOpenJobContacts",
      "ParagraphOpenJobQuote",
      "ParagraphOverlayAccordionItem",
      "ParagraphQuicklinkItem",
      "ParagraphRoomItem",
      "ParagraphRoomOverview",
      "ParagraphRoomOverviewItem",
      "ParagraphSchedule",
      "ParagraphScheduleItem",
      "ParagraphSeatingPlan",
      "ParagraphSeminarListing",
      "ParagraphSeminarTeaser",
      "ParagraphShare",
      "ParagraphShopStartpageInfo",
      "ParagraphShopTeasers",
      "ParagraphSingleTeaser",
      "ParagraphSocialWall",
      "ParagraphSpecificTagsNews",
      "ParagraphStickyEventTeaser",
      "ParagraphStories",
      "ParagraphStoryItem",
      "ParagraphTabItem",
      "ParagraphTable",
      "ParagraphTeaserGrid",
      "ParagraphTeaserGridItem",
      "ParagraphTeaserSlider",
      "ParagraphTeaserSliderItem",
      "ParagraphTeaserTileItem",
      "ParagraphTeaserTiles",
      "ParagraphTestimonial",
      "ParagraphText",
      "ParagraphTextImage",
      "ParagraphTextSidebar",
      "ParagraphTimeline",
      "ParagraphTimelineItem",
      "ParagraphToccoEventSearch",
      "ParagraphTwoColumnText",
      "ParagraphVideo",
      "PathAlias",
      "Pet",
      "RedirectRedirect",
      "ShortcutDefault",
      "SingleTeaser",
      "TaxonomyTermCbzCourseCategory",
      "TaxonomyTermCbzEducation",
      "TaxonomyTermCbzRegion",
      "TaxonomyTermEducationalCourse",
      "TaxonomyTermEventCategory",
      "TaxonomyTermEventInfoType",
      "TaxonomyTermEventType",
      "TaxonomyTermHiddenTags",
      "TaxonomyTermInstitutionSector",
      "TaxonomyTermMediaCategories",
      "TaxonomyTermNewsType",
      "TaxonomyTermTargetGroup",
      "TaxonomyTermToccoCooperationPartner",
      "TaxonomyTermToccoCountry",
      "TaxonomyTermToccoEventCategory",
      "TaxonomyTermToccoEventQualification",
      "TaxonomyTermToccoEventTeachingMethod",
      "TaxonomyTermToccoEventType",
      "TaxonomyTermToccoNativeLanguage",
      "TaxonomyTermToccoSupplyArea",
      "TaxonomyTermToccoTargetGroup",
      "TaxonomyTermVisibleTags",
      "ToccoBaseModule",
      "ToccoConference",
      "ToccoCourse",
      "ToccoELearning",
      "ToccoIntroModule",
      "ToccoModule",
      "ToccoModuleRun",
      "ToccoSeminar",
      "ToccoUser",
      "ToccoWebinar",
      "UnexposedEntity",
      "User",
      "WebformSubmissionAbfrageBetriebeHfPflege",
      "WebformSubmissionAbschiedChristianSchaer",
      "WebformSubmissionAktualitaetenServiceVerlag",
      "WebformSubmissionAktualitaetenServiceVerlagDe",
      "WebformSubmissionAktualitaetenServiceVerlagEn",
      "WebformSubmissionAktualitaetenServiceVerlagFra",
      "WebformSubmissionAktualitaetenServiceVerlagIt",
      "WebformSubmissionAnmeldungBarrierefreiePdfFebr",
      "WebformSubmissionAnmeldungCapitoAiDez24",
      "WebformSubmissionAnmeldungCapitoAiDez25",
      "WebformSubmissionAnmeldungCapitoAiEinfuehrung",
      "WebformSubmissionAnmeldungCapitoAiJanuar25",
      "WebformSubmissionAnmeldungCapitoAiMaerz25",
      "WebformSubmissionAnmeldungCapitoAiMai25",
      "WebformSubmissionAnmeldungCapitoAiSep26",
      "WebformSubmissionAnmeldungCapitoBarrierefreieP",
      "WebformSubmissionAnmeldungCapitoDigitalAugust",
      "WebformSubmissionAnmeldungCapitoDigitalJanuar",
      "WebformSubmissionAnmeldungCapitoDigitalOktober",
      "WebformSubmissionAnmeldungCapitoEinfuehrungswor",
      "WebformSubmissionAnmeldungCapitoEw0525",
      "WebformSubmissionAnmeldungCapitoEwDez24",
      "WebformSubmissionAnmeldungCapitoEwJanuar25",
      "WebformSubmissionAnmeldungCapitoKompaktkurs240",
      "WebformSubmissionAnmeldungCapitoOnlinelehrgang",
      "WebformSubmissionAnmeldungCapitoPraesenzlehrgan",
      "WebformSubmissionAnmeldungCapitoWebinarEBooks",
      "WebformSubmissionAnmeldungCapitoWorkshop325",
      "WebformSubmissionAnmeldungCapitoWorkshop1025",
      "WebformSubmissionAnmeldungCapitoWorkshopNov",
      "WebformSubmissionAnmeldungCareumForum2021",
      "WebformSubmissionAnmeldungEinfuehrungCapitoAi",
      "WebformSubmissionAnmeldungEvent",
      "WebformSubmissionAnmeldungFachUndSelbstkompete",
      "WebformSubmissionAnmeldungFotoshooting",
      "WebformSubmissionAnmeldungFotoshootingJanuar20",
      "WebformSubmissionAnmeldungFreikursEnglisch",
      "WebformSubmissionAnmeldungFreikursInformatik",
      "WebformSubmissionAnmeldungFremdbeurteilungBetri",
      "WebformSubmissionAnmeldungLehrgaengeAltern",
      "WebformSubmissionAnmeldungVernissageYoungCarer",
      "WebformSubmissionAnmeldungVertiefungskursBarrie",
      "WebformSubmissionAnmeldungVorkursAnatomiePhysi",
      "WebformSubmissionAnmeldungVorkursMathematikPhy",
      "WebformSubmissionAnmeldungWebinarAgsEBooksVe",
      "WebformSubmissionAnmeldungWebinarApothekeEBoo",
      "WebformSubmissionAnmeldungWebinarDrogistinEBo",
      "WebformSubmissionAnmeldungWebinarFabeEBooksV",
      "WebformSubmissionAnmeldungWebinarFabeEbooks25",
      "WebformSubmissionAnmeldungWebinarFageEBooks9",
      "WebformSubmissionAnmeldungWebinarFageEBooksV",
      "WebformSubmissionAnmeldungWebinarGesundheitskom",
      "WebformSubmissionAnmeldungWebinarGkFr",
      "WebformSubmissionAnmeldungWebinarMpaEBooksVe",
      "WebformSubmissionAnmeldungZumAbschiedsanlassVo",
      "WebformSubmissionBfsAnmeldungElternUndSupport",
      "WebformSubmissionBfsFageAnmeldungLehrbetriebe",
      "WebformSubmissionCwbAnmeldungDozierendentreffen",
      "WebformSubmissionDigitalesZulassungsverfahrenZo",
      "WebformSubmissionEMailTest",
      "WebformSubmissionEinverstaendniserklaerungVerlag",
      "WebformSubmissionEinverstaendniserklaerungVerwen",
      "WebformSubmissionEntity",
      "WebformSubmissionFeedbackLehrmittel",
      "WebformSubmissionFeedbackLehrmittelEnglisch",
      "WebformSubmissionFeedbackLehrmittelFranzoesisch",
      "WebformSubmissionFeedbackLehrmittelIt",
      "WebformSubmissionFeedbackMaengelWebsite",
      "WebformSubmissionFremdbeurteilungHfBma",
      "WebformSubmissionFremdbeurteilungHfMtr",
      "WebformSubmissionFremdbeurteilungHfOt",
      "WebformSubmissionHfBmaAnmeldungPraktikumsbetri",
      "WebformSubmissionHfDhAnmeldungPraktikumsbetrie",
      "WebformSubmissionHfDhBedarfsabklaerungFuerPra",
      "WebformSubmissionHfMtrAnmeldungPraktikumsbetri",
      "WebformSubmissionHfOtAnmeldungPraktikumsbetrie",
      "WebformSubmissionHfPflegeAnmeldungPraktikumsbe",
      "WebformSubmissionHoehereFachschuleBetriebePod",
      "WebformSubmissionInfotagGesundheit2022",
      "WebformSubmissionKiInDerBerufsbildung",
      "WebformSubmissionKontaktanfrageAuditorium",
      "WebformSubmissionKontaktformularCareumVerlag",
      "WebformSubmissionKontaktformularPruefgruppeLeic",
      "WebformSubmissionKontaktformularVerlag",
      "WebformSubmissionKontaktformularVerlagEn",
      "WebformSubmissionKontaktformularVerlagFr",
      "WebformSubmissionKontaktformularVerlagIt",
      "WebformSubmissionKundendaten",
      "WebformSubmissionLernberatungMitSicherheitImP",
      "WebformSubmissionMarketingmaterial",
      "WebformSubmissionNeuerZusatztitelProfessionalB",
      "WebformSubmissionNewsletterAnmeldungCapitoVerl",
      "WebformSubmissionNewsletterAnmeldungSphere",
      "WebformSubmissionNewsletterCareumVerlagSphere",
      "WebformSubmissionNewsletterCareumWeiterbildung",
      "WebformSubmissionNewsletterVerlag",
      "WebformSubmissionNewsletterVerlagSphereFr",
      "WebformSubmissionNewsletterVerlagSphereIt",
      "WebformSubmissionPruefungssituationErfolgreichM",
      "WebformSubmissionSprechstundenInteressierteBetr",
      "WebformSubmissionSprechstundenPraktikumsbetriebe",
      "WebformSubmissionStandardFormular",
      "WebformSubmissionTestFormular",
      "WebformSubmissionTestSeline",
      "WebformSubmissionWebinarProfessionelleGesundhei"
    ],
    "EntityDescribable": [],
    "EntityOwnable": [
      "CommentComment",
      "ContentModerationState",
      "File",
      "MediaAudio",
      "MediaCbzDocument",
      "MediaDocument",
      "MediaImage",
      "MediaRemoteVideo",
      "MediaToccoDocument",
      "MediaVideo",
      "NodeCbzLandingPage",
      "NodeEvent",
      "NodeLandingPage",
      "NodeNews",
      "NodeOpenJob",
      "NodePage",
      "NodePracticas",
      "NodeProtectedPage",
      "OverlayElement",
      "ParagraphAccordion",
      "ParagraphAccordionItem",
      "ParagraphAnchor",
      "ParagraphAnchors",
      "ParagraphAuthorSidebar",
      "ParagraphCarousel",
      "ParagraphCarouselItem",
      "ParagraphCbzAccordion",
      "ParagraphCbzAccordionContentItem",
      "ParagraphCbzAccordionItem",
      "ParagraphCbzDownloads",
      "ParagraphCbzLinkItem",
      "ParagraphCbzLinks",
      "ParagraphCbzListing",
      "ParagraphCbzNewContent",
      "ParagraphCbzNewsletter",
      "ParagraphContact",
      "ParagraphContactAccordionItem",
      "ParagraphContactPerson",
      "ParagraphContainerWidgetMain",
      "ParagraphContainerWidgetSidebar",
      "ParagraphCourseListing",
      "ParagraphCourseTeaser",
      "ParagraphCtaSidebar",
      "ParagraphDownloads",
      "ParagraphELearningListing",
      "ParagraphEducationOfferingItem",
      "ParagraphEducationOverview",
      "ParagraphEducationOverviewItem",
      "ParagraphEducationOverviewTeaserItem",
      "ParagraphEventListing",
      "ParagraphEventRegistration",
      "ParagraphEventTeasers",
      "ParagraphFeaturedNewsPosts",
      "ParagraphForm",
      "ParagraphFullHtmlText",
      "ParagraphHeading",
      "ParagraphHero",
      "ParagraphHeroHomepage",
      "ParagraphHeroItem",
      "ParagraphHotspotGraphic",
      "ParagraphHotspotItem",
      "ParagraphIconSectionItem",
      "ParagraphIframe",
      "ParagraphImage",
      "ParagraphInfoBox",
      "ParagraphInfoItems",
      "ParagraphIntrotext",
      "ParagraphJsScripts",
      "ParagraphLabelValueContent",
      "ParagraphLabelValueItem",
      "ParagraphLabelValueSidebar",
      "ParagraphLargeLinklist",
      "ParagraphLargeLinklistItem",
      "ParagraphLatestEducationOfferings",
      "ParagraphLegendItem",
      "ParagraphLinklist",
      "ParagraphListing",
      "ParagraphLogoSidebar",
      "ParagraphMap",
      "ParagraphMegaTeaser",
      "ParagraphMegaTeaserItem",
      "ParagraphOpenJobContactItem",
      "ParagraphOpenJobContacts",
      "ParagraphOpenJobQuote",
      "ParagraphOverlayAccordionItem",
      "ParagraphQuicklinkItem",
      "ParagraphRoomItem",
      "ParagraphRoomOverview",
      "ParagraphRoomOverviewItem",
      "ParagraphSchedule",
      "ParagraphScheduleItem",
      "ParagraphSeatingPlan",
      "ParagraphSeminarListing",
      "ParagraphSeminarTeaser",
      "ParagraphShare",
      "ParagraphShopStartpageInfo",
      "ParagraphShopTeasers",
      "ParagraphSingleTeaser",
      "ParagraphSocialWall",
      "ParagraphSpecificTagsNews",
      "ParagraphStickyEventTeaser",
      "ParagraphStories",
      "ParagraphStoryItem",
      "ParagraphTabItem",
      "ParagraphTable",
      "ParagraphTeaserGrid",
      "ParagraphTeaserGridItem",
      "ParagraphTeaserSlider",
      "ParagraphTeaserSliderItem",
      "ParagraphTeaserTileItem",
      "ParagraphTeaserTiles",
      "ParagraphTestimonial",
      "ParagraphText",
      "ParagraphTextImage",
      "ParagraphTextSidebar",
      "ParagraphTimeline",
      "ParagraphTimelineItem",
      "ParagraphToccoEventSearch",
      "ParagraphTwoColumnText",
      "ParagraphVideo",
      "ToccoConference",
      "WebformSubmissionAbfrageBetriebeHfPflege",
      "WebformSubmissionAbschiedChristianSchaer",
      "WebformSubmissionAktualitaetenServiceVerlag",
      "WebformSubmissionAktualitaetenServiceVerlagDe",
      "WebformSubmissionAktualitaetenServiceVerlagEn",
      "WebformSubmissionAktualitaetenServiceVerlagFra",
      "WebformSubmissionAktualitaetenServiceVerlagIt",
      "WebformSubmissionAnmeldungBarrierefreiePdfFebr",
      "WebformSubmissionAnmeldungCapitoAiDez24",
      "WebformSubmissionAnmeldungCapitoAiDez25",
      "WebformSubmissionAnmeldungCapitoAiEinfuehrung",
      "WebformSubmissionAnmeldungCapitoAiJanuar25",
      "WebformSubmissionAnmeldungCapitoAiMaerz25",
      "WebformSubmissionAnmeldungCapitoAiMai25",
      "WebformSubmissionAnmeldungCapitoAiSep26",
      "WebformSubmissionAnmeldungCapitoBarrierefreieP",
      "WebformSubmissionAnmeldungCapitoDigitalAugust",
      "WebformSubmissionAnmeldungCapitoDigitalJanuar",
      "WebformSubmissionAnmeldungCapitoDigitalOktober",
      "WebformSubmissionAnmeldungCapitoEinfuehrungswor",
      "WebformSubmissionAnmeldungCapitoEw0525",
      "WebformSubmissionAnmeldungCapitoEwDez24",
      "WebformSubmissionAnmeldungCapitoEwJanuar25",
      "WebformSubmissionAnmeldungCapitoKompaktkurs240",
      "WebformSubmissionAnmeldungCapitoOnlinelehrgang",
      "WebformSubmissionAnmeldungCapitoPraesenzlehrgan",
      "WebformSubmissionAnmeldungCapitoWebinarEBooks",
      "WebformSubmissionAnmeldungCapitoWorkshop325",
      "WebformSubmissionAnmeldungCapitoWorkshop1025",
      "WebformSubmissionAnmeldungCapitoWorkshopNov",
      "WebformSubmissionAnmeldungCareumForum2021",
      "WebformSubmissionAnmeldungEinfuehrungCapitoAi",
      "WebformSubmissionAnmeldungEvent",
      "WebformSubmissionAnmeldungFachUndSelbstkompete",
      "WebformSubmissionAnmeldungFotoshooting",
      "WebformSubmissionAnmeldungFotoshootingJanuar20",
      "WebformSubmissionAnmeldungFreikursEnglisch",
      "WebformSubmissionAnmeldungFreikursInformatik",
      "WebformSubmissionAnmeldungFremdbeurteilungBetri",
      "WebformSubmissionAnmeldungLehrgaengeAltern",
      "WebformSubmissionAnmeldungVernissageYoungCarer",
      "WebformSubmissionAnmeldungVertiefungskursBarrie",
      "WebformSubmissionAnmeldungVorkursAnatomiePhysi",
      "WebformSubmissionAnmeldungVorkursMathematikPhy",
      "WebformSubmissionAnmeldungWebinarAgsEBooksVe",
      "WebformSubmissionAnmeldungWebinarApothekeEBoo",
      "WebformSubmissionAnmeldungWebinarDrogistinEBo",
      "WebformSubmissionAnmeldungWebinarFabeEBooksV",
      "WebformSubmissionAnmeldungWebinarFabeEbooks25",
      "WebformSubmissionAnmeldungWebinarFageEBooks9",
      "WebformSubmissionAnmeldungWebinarFageEBooksV",
      "WebformSubmissionAnmeldungWebinarGesundheitskom",
      "WebformSubmissionAnmeldungWebinarGkFr",
      "WebformSubmissionAnmeldungWebinarMpaEBooksVe",
      "WebformSubmissionAnmeldungZumAbschiedsanlassVo",
      "WebformSubmissionBfsAnmeldungElternUndSupport",
      "WebformSubmissionBfsFageAnmeldungLehrbetriebe",
      "WebformSubmissionCwbAnmeldungDozierendentreffen",
      "WebformSubmissionDigitalesZulassungsverfahrenZo",
      "WebformSubmissionEMailTest",
      "WebformSubmissionEinverstaendniserklaerungVerlag",
      "WebformSubmissionEinverstaendniserklaerungVerwen",
      "WebformSubmissionEntity",
      "WebformSubmissionFeedbackLehrmittel",
      "WebformSubmissionFeedbackLehrmittelEnglisch",
      "WebformSubmissionFeedbackLehrmittelFranzoesisch",
      "WebformSubmissionFeedbackLehrmittelIt",
      "WebformSubmissionFeedbackMaengelWebsite",
      "WebformSubmissionFremdbeurteilungHfBma",
      "WebformSubmissionFremdbeurteilungHfMtr",
      "WebformSubmissionFremdbeurteilungHfOt",
      "WebformSubmissionHfBmaAnmeldungPraktikumsbetri",
      "WebformSubmissionHfDhAnmeldungPraktikumsbetrie",
      "WebformSubmissionHfDhBedarfsabklaerungFuerPra",
      "WebformSubmissionHfMtrAnmeldungPraktikumsbetri",
      "WebformSubmissionHfOtAnmeldungPraktikumsbetrie",
      "WebformSubmissionHfPflegeAnmeldungPraktikumsbe",
      "WebformSubmissionHoehereFachschuleBetriebePod",
      "WebformSubmissionInfotagGesundheit2022",
      "WebformSubmissionKiInDerBerufsbildung",
      "WebformSubmissionKontaktanfrageAuditorium",
      "WebformSubmissionKontaktformularCareumVerlag",
      "WebformSubmissionKontaktformularPruefgruppeLeic",
      "WebformSubmissionKontaktformularVerlag",
      "WebformSubmissionKontaktformularVerlagEn",
      "WebformSubmissionKontaktformularVerlagFr",
      "WebformSubmissionKontaktformularVerlagIt",
      "WebformSubmissionKundendaten",
      "WebformSubmissionLernberatungMitSicherheitImP",
      "WebformSubmissionMarketingmaterial",
      "WebformSubmissionNeuerZusatztitelProfessionalB",
      "WebformSubmissionNewsletterAnmeldungCapitoVerl",
      "WebformSubmissionNewsletterAnmeldungSphere",
      "WebformSubmissionNewsletterCareumVerlagSphere",
      "WebformSubmissionNewsletterCareumWeiterbildung",
      "WebformSubmissionNewsletterVerlag",
      "WebformSubmissionNewsletterVerlagSphereFr",
      "WebformSubmissionNewsletterVerlagSphereIt",
      "WebformSubmissionPruefungssituationErfolgreichM",
      "WebformSubmissionSprechstundenInteressierteBetr",
      "WebformSubmissionSprechstundenPraktikumsbetriebe",
      "WebformSubmissionStandardFormular",
      "WebformSubmissionTestFormular",
      "WebformSubmissionTestSeline",
      "WebformSubmissionWebinarProfessionelleGesundhei"
    ],
    "EntityPublishable": [
      "Author",
      "BlockContentBasic",
      "CbzLink",
      "CommentComment",
      "ContactPerson",
      "ContainerWidgetMain",
      "ContainerWidgetSidebar",
      "InfoBox",
      "Linkcheckerlink",
      "MediaAudio",
      "MediaCbzDocument",
      "MediaDocument",
      "MediaImage",
      "MediaRemoteVideo",
      "MediaToccoDocument",
      "MediaVideo",
      "MenuLinkContentAccount",
      "MenuLinkContentAdmin",
      "MenuLinkContentComplianceMenu",
      "MenuLinkContentFooter",
      "MenuLinkContentMain",
      "MenuLinkContentMetaMenu",
      "MenuLinkContentTools",
      "NodeCbzLandingPage",
      "NodeEvent",
      "NodeLandingPage",
      "NodeNews",
      "NodeOpenJob",
      "NodePage",
      "NodePracticas",
      "NodeProtectedPage",
      "ParagraphAccordion",
      "ParagraphAccordionItem",
      "ParagraphAnchor",
      "ParagraphAnchors",
      "ParagraphAuthorSidebar",
      "ParagraphCarousel",
      "ParagraphCarouselItem",
      "ParagraphCbzAccordion",
      "ParagraphCbzAccordionContentItem",
      "ParagraphCbzAccordionItem",
      "ParagraphCbzDownloads",
      "ParagraphCbzLinkItem",
      "ParagraphCbzLinks",
      "ParagraphCbzListing",
      "ParagraphCbzNewContent",
      "ParagraphCbzNewsletter",
      "ParagraphContact",
      "ParagraphContactAccordionItem",
      "ParagraphContactPerson",
      "ParagraphContainerWidgetMain",
      "ParagraphContainerWidgetSidebar",
      "ParagraphCourseListing",
      "ParagraphCourseTeaser",
      "ParagraphCtaSidebar",
      "ParagraphDownloads",
      "ParagraphELearningListing",
      "ParagraphEducationOfferingItem",
      "ParagraphEducationOverview",
      "ParagraphEducationOverviewItem",
      "ParagraphEducationOverviewTeaserItem",
      "ParagraphEventListing",
      "ParagraphEventRegistration",
      "ParagraphEventTeasers",
      "ParagraphFeaturedNewsPosts",
      "ParagraphForm",
      "ParagraphFullHtmlText",
      "ParagraphHeading",
      "ParagraphHero",
      "ParagraphHeroHomepage",
      "ParagraphHeroItem",
      "ParagraphHotspotGraphic",
      "ParagraphHotspotItem",
      "ParagraphIconSectionItem",
      "ParagraphIframe",
      "ParagraphImage",
      "ParagraphInfoBox",
      "ParagraphInfoItems",
      "ParagraphIntrotext",
      "ParagraphJsScripts",
      "ParagraphLabelValueContent",
      "ParagraphLabelValueItem",
      "ParagraphLabelValueSidebar",
      "ParagraphLargeLinklist",
      "ParagraphLargeLinklistItem",
      "ParagraphLatestEducationOfferings",
      "ParagraphLegendItem",
      "ParagraphLinklist",
      "ParagraphListing",
      "ParagraphLogoSidebar",
      "ParagraphMap",
      "ParagraphMegaTeaser",
      "ParagraphMegaTeaserItem",
      "ParagraphOpenJobContactItem",
      "ParagraphOpenJobContacts",
      "ParagraphOpenJobQuote",
      "ParagraphOverlayAccordionItem",
      "ParagraphQuicklinkItem",
      "ParagraphRoomItem",
      "ParagraphRoomOverview",
      "ParagraphRoomOverviewItem",
      "ParagraphSchedule",
      "ParagraphScheduleItem",
      "ParagraphSeatingPlan",
      "ParagraphSeminarListing",
      "ParagraphSeminarTeaser",
      "ParagraphShare",
      "ParagraphShopStartpageInfo",
      "ParagraphShopTeasers",
      "ParagraphSingleTeaser",
      "ParagraphSocialWall",
      "ParagraphSpecificTagsNews",
      "ParagraphStickyEventTeaser",
      "ParagraphStories",
      "ParagraphStoryItem",
      "ParagraphTabItem",
      "ParagraphTable",
      "ParagraphTeaserGrid",
      "ParagraphTeaserGridItem",
      "ParagraphTeaserSlider",
      "ParagraphTeaserSliderItem",
      "ParagraphTeaserTileItem",
      "ParagraphTeaserTiles",
      "ParagraphTestimonial",
      "ParagraphText",
      "ParagraphTextImage",
      "ParagraphTextSidebar",
      "ParagraphTimeline",
      "ParagraphTimelineItem",
      "ParagraphToccoEventSearch",
      "ParagraphTwoColumnText",
      "ParagraphVideo",
      "PathAlias",
      "RedirectRedirect",
      "SingleTeaser",
      "TaxonomyTermCbzCourseCategory",
      "TaxonomyTermCbzEducation",
      "TaxonomyTermCbzRegion",
      "TaxonomyTermEducationalCourse",
      "TaxonomyTermEventCategory",
      "TaxonomyTermEventInfoType",
      "TaxonomyTermEventType",
      "TaxonomyTermHiddenTags",
      "TaxonomyTermInstitutionSector",
      "TaxonomyTermMediaCategories",
      "TaxonomyTermNewsType",
      "TaxonomyTermTargetGroup",
      "TaxonomyTermToccoCooperationPartner",
      "TaxonomyTermToccoCountry",
      "TaxonomyTermToccoEventCategory",
      "TaxonomyTermToccoEventQualification",
      "TaxonomyTermToccoEventTeachingMethod",
      "TaxonomyTermToccoEventType",
      "TaxonomyTermToccoNativeLanguage",
      "TaxonomyTermToccoSupplyArea",
      "TaxonomyTermToccoTargetGroup",
      "TaxonomyTermVisibleTags"
    ],
    "EntityRevisionable": [
      "Author",
      "BlockContentBasic",
      "CbzLink",
      "ContactPerson",
      "ContainerWidgetMain",
      "ContainerWidgetSidebar",
      "ContentModerationState",
      "InfoBox",
      "MediaAudio",
      "MediaCbzDocument",
      "MediaDocument",
      "MediaImage",
      "MediaRemoteVideo",
      "MediaToccoDocument",
      "MediaVideo",
      "MenuLinkContentAccount",
      "MenuLinkContentAdmin",
      "MenuLinkContentComplianceMenu",
      "MenuLinkContentFooter",
      "MenuLinkContentMain",
      "MenuLinkContentMetaMenu",
      "MenuLinkContentTools",
      "NodeCbzLandingPage",
      "NodeEvent",
      "NodeLandingPage",
      "NodeNews",
      "NodeOpenJob",
      "NodePage",
      "NodePracticas",
      "NodeProtectedPage",
      "OverlayElement",
      "ParagraphAccordion",
      "ParagraphAccordionItem",
      "ParagraphAnchor",
      "ParagraphAnchors",
      "ParagraphAuthorSidebar",
      "ParagraphCarousel",
      "ParagraphCarouselItem",
      "ParagraphCbzAccordion",
      "ParagraphCbzAccordionContentItem",
      "ParagraphCbzAccordionItem",
      "ParagraphCbzDownloads",
      "ParagraphCbzLinkItem",
      "ParagraphCbzLinks",
      "ParagraphCbzListing",
      "ParagraphCbzNewContent",
      "ParagraphCbzNewsletter",
      "ParagraphContact",
      "ParagraphContactAccordionItem",
      "ParagraphContactPerson",
      "ParagraphContainerWidgetMain",
      "ParagraphContainerWidgetSidebar",
      "ParagraphCourseListing",
      "ParagraphCourseTeaser",
      "ParagraphCtaSidebar",
      "ParagraphDownloads",
      "ParagraphELearningListing",
      "ParagraphEducationOfferingItem",
      "ParagraphEducationOverview",
      "ParagraphEducationOverviewItem",
      "ParagraphEducationOverviewTeaserItem",
      "ParagraphEventListing",
      "ParagraphEventRegistration",
      "ParagraphEventTeasers",
      "ParagraphFeaturedNewsPosts",
      "ParagraphForm",
      "ParagraphFullHtmlText",
      "ParagraphHeading",
      "ParagraphHero",
      "ParagraphHeroHomepage",
      "ParagraphHeroItem",
      "ParagraphHotspotGraphic",
      "ParagraphHotspotItem",
      "ParagraphIconSectionItem",
      "ParagraphIframe",
      "ParagraphImage",
      "ParagraphInfoBox",
      "ParagraphInfoItems",
      "ParagraphIntrotext",
      "ParagraphJsScripts",
      "ParagraphLabelValueContent",
      "ParagraphLabelValueItem",
      "ParagraphLabelValueSidebar",
      "ParagraphLargeLinklist",
      "ParagraphLargeLinklistItem",
      "ParagraphLatestEducationOfferings",
      "ParagraphLegendItem",
      "ParagraphLinklist",
      "ParagraphListing",
      "ParagraphLogoSidebar",
      "ParagraphMap",
      "ParagraphMegaTeaser",
      "ParagraphMegaTeaserItem",
      "ParagraphOpenJobContactItem",
      "ParagraphOpenJobContacts",
      "ParagraphOpenJobQuote",
      "ParagraphOverlayAccordionItem",
      "ParagraphQuicklinkItem",
      "ParagraphRoomItem",
      "ParagraphRoomOverview",
      "ParagraphRoomOverviewItem",
      "ParagraphSchedule",
      "ParagraphScheduleItem",
      "ParagraphSeatingPlan",
      "ParagraphSeminarListing",
      "ParagraphSeminarTeaser",
      "ParagraphShare",
      "ParagraphShopStartpageInfo",
      "ParagraphShopTeasers",
      "ParagraphSingleTeaser",
      "ParagraphSocialWall",
      "ParagraphSpecificTagsNews",
      "ParagraphStickyEventTeaser",
      "ParagraphStories",
      "ParagraphStoryItem",
      "ParagraphTabItem",
      "ParagraphTable",
      "ParagraphTeaserGrid",
      "ParagraphTeaserGridItem",
      "ParagraphTeaserSlider",
      "ParagraphTeaserSliderItem",
      "ParagraphTeaserTileItem",
      "ParagraphTeaserTiles",
      "ParagraphTestimonial",
      "ParagraphText",
      "ParagraphTextImage",
      "ParagraphTextSidebar",
      "ParagraphTimeline",
      "ParagraphTimelineItem",
      "ParagraphToccoEventSearch",
      "ParagraphTwoColumnText",
      "ParagraphVideo",
      "PathAlias",
      "SingleTeaser",
      "TaxonomyTermCbzCourseCategory",
      "TaxonomyTermCbzEducation",
      "TaxonomyTermCbzRegion",
      "TaxonomyTermEducationalCourse",
      "TaxonomyTermEventCategory",
      "TaxonomyTermEventInfoType",
      "TaxonomyTermEventType",
      "TaxonomyTermHiddenTags",
      "TaxonomyTermInstitutionSector",
      "TaxonomyTermMediaCategories",
      "TaxonomyTermNewsType",
      "TaxonomyTermTargetGroup",
      "TaxonomyTermToccoCooperationPartner",
      "TaxonomyTermToccoCountry",
      "TaxonomyTermToccoEventCategory",
      "TaxonomyTermToccoEventQualification",
      "TaxonomyTermToccoEventTeachingMethod",
      "TaxonomyTermToccoEventType",
      "TaxonomyTermToccoNativeLanguage",
      "TaxonomyTermToccoSupplyArea",
      "TaxonomyTermToccoTargetGroup",
      "TaxonomyTermVisibleTags"
    ],
    "InternalUrl": [
      "DefaultInternalUrl",
      "EntityCanonicalUrl"
    ],
    "Media": [
      "MediaAudio",
      "MediaCbzDocument",
      "MediaDocument",
      "MediaImage",
      "MediaRemoteVideo",
      "MediaToccoDocument",
      "MediaVideo"
    ],
    "MenuLinkContent": [
      "MenuLinkContentAccount",
      "MenuLinkContentAdmin",
      "MenuLinkContentComplianceMenu",
      "MenuLinkContentFooter",
      "MenuLinkContentMain",
      "MenuLinkContentMetaMenu",
      "MenuLinkContentTools"
    ],
    "Metatag": [
      "MetaHttpEquiv",
      "MetaItemProp",
      "MetaLink",
      "MetaLinkHreflang",
      "MetaProperty",
      "MetaValue"
    ],
    "Node": [
      "NodeCbzLandingPage",
      "NodeEvent",
      "NodeLandingPage",
      "NodeNews",
      "NodeOpenJob",
      "NodePage",
      "NodePracticas",
      "NodeProtectedPage"
    ],
    "Paragraph": [
      "ParagraphAccordion",
      "ParagraphAccordionItem",
      "ParagraphAnchor",
      "ParagraphAnchors",
      "ParagraphAuthorSidebar",
      "ParagraphCarousel",
      "ParagraphCarouselItem",
      "ParagraphCbzAccordion",
      "ParagraphCbzAccordionContentItem",
      "ParagraphCbzAccordionItem",
      "ParagraphCbzDownloads",
      "ParagraphCbzLinkItem",
      "ParagraphCbzLinks",
      "ParagraphCbzListing",
      "ParagraphCbzNewContent",
      "ParagraphCbzNewsletter",
      "ParagraphContact",
      "ParagraphContactAccordionItem",
      "ParagraphContactPerson",
      "ParagraphContainerWidgetMain",
      "ParagraphContainerWidgetSidebar",
      "ParagraphCourseListing",
      "ParagraphCourseTeaser",
      "ParagraphCtaSidebar",
      "ParagraphDownloads",
      "ParagraphELearningListing",
      "ParagraphEducationOfferingItem",
      "ParagraphEducationOverview",
      "ParagraphEducationOverviewItem",
      "ParagraphEducationOverviewTeaserItem",
      "ParagraphEventListing",
      "ParagraphEventRegistration",
      "ParagraphEventTeasers",
      "ParagraphFeaturedNewsPosts",
      "ParagraphForm",
      "ParagraphFullHtmlText",
      "ParagraphHeading",
      "ParagraphHero",
      "ParagraphHeroHomepage",
      "ParagraphHeroItem",
      "ParagraphHotspotGraphic",
      "ParagraphHotspotItem",
      "ParagraphIconSectionItem",
      "ParagraphIframe",
      "ParagraphImage",
      "ParagraphInfoBox",
      "ParagraphInfoItems",
      "ParagraphIntrotext",
      "ParagraphJsScripts",
      "ParagraphLabelValueContent",
      "ParagraphLabelValueItem",
      "ParagraphLabelValueSidebar",
      "ParagraphLargeLinklist",
      "ParagraphLargeLinklistItem",
      "ParagraphLatestEducationOfferings",
      "ParagraphLegendItem",
      "ParagraphLinklist",
      "ParagraphListing",
      "ParagraphLogoSidebar",
      "ParagraphMap",
      "ParagraphMegaTeaser",
      "ParagraphMegaTeaserItem",
      "ParagraphOpenJobContactItem",
      "ParagraphOpenJobContacts",
      "ParagraphOpenJobQuote",
      "ParagraphOverlayAccordionItem",
      "ParagraphQuicklinkItem",
      "ParagraphRoomItem",
      "ParagraphRoomOverview",
      "ParagraphRoomOverviewItem",
      "ParagraphSchedule",
      "ParagraphScheduleItem",
      "ParagraphSeatingPlan",
      "ParagraphSeminarListing",
      "ParagraphSeminarTeaser",
      "ParagraphShare",
      "ParagraphShopStartpageInfo",
      "ParagraphShopTeasers",
      "ParagraphSingleTeaser",
      "ParagraphSocialWall",
      "ParagraphSpecificTagsNews",
      "ParagraphStickyEventTeaser",
      "ParagraphStories",
      "ParagraphStoryItem",
      "ParagraphTabItem",
      "ParagraphTable",
      "ParagraphTeaserGrid",
      "ParagraphTeaserGridItem",
      "ParagraphTeaserSlider",
      "ParagraphTeaserSliderItem",
      "ParagraphTeaserTileItem",
      "ParagraphTeaserTiles",
      "ParagraphTestimonial",
      "ParagraphText",
      "ParagraphTextImage",
      "ParagraphTextSidebar",
      "ParagraphTimeline",
      "ParagraphTimelineItem",
      "ParagraphToccoEventSearch",
      "ParagraphTwoColumnText",
      "ParagraphVideo"
    ],
    "Redirect": [
      "RedirectRedirect"
    ],
    "Shortcut": [
      "ShortcutDefault"
    ],
    "TaxonomyTerm": [
      "TaxonomyTermCbzCourseCategory",
      "TaxonomyTermCbzEducation",
      "TaxonomyTermCbzRegion",
      "TaxonomyTermEducationalCourse",
      "TaxonomyTermEventCategory",
      "TaxonomyTermEventInfoType",
      "TaxonomyTermEventType",
      "TaxonomyTermHiddenTags",
      "TaxonomyTermInstitutionSector",
      "TaxonomyTermMediaCategories",
      "TaxonomyTermNewsType",
      "TaxonomyTermTargetGroup",
      "TaxonomyTermToccoCooperationPartner",
      "TaxonomyTermToccoCountry",
      "TaxonomyTermToccoEventCategory",
      "TaxonomyTermToccoEventQualification",
      "TaxonomyTermToccoEventTeachingMethod",
      "TaxonomyTermToccoEventType",
      "TaxonomyTermToccoNativeLanguage",
      "TaxonomyTermToccoSupplyArea",
      "TaxonomyTermToccoTargetGroup",
      "TaxonomyTermVisibleTags"
    ],
    "Tocco": [
      "ToccoBaseModule",
      "ToccoCourse",
      "ToccoELearning",
      "ToccoIntroModule",
      "ToccoModule",
      "ToccoModuleRun",
      "ToccoSeminar",
      "ToccoUser",
      "ToccoWebinar"
    ],
    "Url": [
      "DefaultInternalUrl",
      "EntityCanonicalUrl",
      "ExternalUrl",
      "RedirectUrl"
    ],
    "WebformElement": [
      "WebformElementActions",
      "WebformElementCheckbox",
      "WebformElementCheckboxes",
      "WebformElementComposite",
      "WebformElementContainer",
      "WebformElementDate",
      "WebformElementEmail",
      "WebformElementEntitySelect",
      "WebformElementFlexbox",
      "WebformElementHidden",
      "WebformElementManagedFile",
      "WebformElementMarkup",
      "WebformElementNumber",
      "WebformElementPhone",
      "WebformElementRadios",
      "WebformElementSection",
      "WebformElementSelect",
      "WebformElementTermSelect",
      "WebformElementTextField",
      "WebformElementTextarea",
      "WebformElementTime",
      "WebformElementToggleSwitch",
      "WebformElementType"
    ],
    "WebformElementDateBase": [
      "WebformElementDate"
    ],
    "WebformElementManagedFileBase": [
      "WebformElementManagedFile"
    ],
    "WebformElementOptionsBase": [
      "WebformElementCheckboxes",
      "WebformElementEntitySelect",
      "WebformElementRadios",
      "WebformElementSelect",
      "WebformElementTermSelect"
    ],
    "WebformElementTextBase": [
      "WebformElementEmail",
      "WebformElementPhone",
      "WebformElementTextField",
      "WebformElementTextarea",
      "WebformElementToggleSwitch"
    ],
    "WebformElementTimeBase": [
      "WebformElementTime"
    ],
    "WebformSubmission": [
      "WebformSubmissionAbfrageBetriebeHfPflege",
      "WebformSubmissionAbschiedChristianSchaer",
      "WebformSubmissionAktualitaetenServiceVerlag",
      "WebformSubmissionAktualitaetenServiceVerlagDe",
      "WebformSubmissionAktualitaetenServiceVerlagEn",
      "WebformSubmissionAktualitaetenServiceVerlagFra",
      "WebformSubmissionAktualitaetenServiceVerlagIt",
      "WebformSubmissionAnmeldungBarrierefreiePdfFebr",
      "WebformSubmissionAnmeldungCapitoAiDez24",
      "WebformSubmissionAnmeldungCapitoAiDez25",
      "WebformSubmissionAnmeldungCapitoAiEinfuehrung",
      "WebformSubmissionAnmeldungCapitoAiJanuar25",
      "WebformSubmissionAnmeldungCapitoAiMaerz25",
      "WebformSubmissionAnmeldungCapitoAiMai25",
      "WebformSubmissionAnmeldungCapitoAiSep26",
      "WebformSubmissionAnmeldungCapitoBarrierefreieP",
      "WebformSubmissionAnmeldungCapitoDigitalAugust",
      "WebformSubmissionAnmeldungCapitoDigitalJanuar",
      "WebformSubmissionAnmeldungCapitoDigitalOktober",
      "WebformSubmissionAnmeldungCapitoEinfuehrungswor",
      "WebformSubmissionAnmeldungCapitoEw0525",
      "WebformSubmissionAnmeldungCapitoEwDez24",
      "WebformSubmissionAnmeldungCapitoEwJanuar25",
      "WebformSubmissionAnmeldungCapitoKompaktkurs240",
      "WebformSubmissionAnmeldungCapitoOnlinelehrgang",
      "WebformSubmissionAnmeldungCapitoPraesenzlehrgan",
      "WebformSubmissionAnmeldungCapitoWebinarEBooks",
      "WebformSubmissionAnmeldungCapitoWorkshop325",
      "WebformSubmissionAnmeldungCapitoWorkshop1025",
      "WebformSubmissionAnmeldungCapitoWorkshopNov",
      "WebformSubmissionAnmeldungCareumForum2021",
      "WebformSubmissionAnmeldungEinfuehrungCapitoAi",
      "WebformSubmissionAnmeldungEvent",
      "WebformSubmissionAnmeldungFachUndSelbstkompete",
      "WebformSubmissionAnmeldungFotoshooting",
      "WebformSubmissionAnmeldungFotoshootingJanuar20",
      "WebformSubmissionAnmeldungFreikursEnglisch",
      "WebformSubmissionAnmeldungFreikursInformatik",
      "WebformSubmissionAnmeldungFremdbeurteilungBetri",
      "WebformSubmissionAnmeldungLehrgaengeAltern",
      "WebformSubmissionAnmeldungVernissageYoungCarer",
      "WebformSubmissionAnmeldungVertiefungskursBarrie",
      "WebformSubmissionAnmeldungVorkursAnatomiePhysi",
      "WebformSubmissionAnmeldungVorkursMathematikPhy",
      "WebformSubmissionAnmeldungWebinarAgsEBooksVe",
      "WebformSubmissionAnmeldungWebinarApothekeEBoo",
      "WebformSubmissionAnmeldungWebinarDrogistinEBo",
      "WebformSubmissionAnmeldungWebinarFabeEBooksV",
      "WebformSubmissionAnmeldungWebinarFabeEbooks25",
      "WebformSubmissionAnmeldungWebinarFageEBooks9",
      "WebformSubmissionAnmeldungWebinarFageEBooksV",
      "WebformSubmissionAnmeldungWebinarGesundheitskom",
      "WebformSubmissionAnmeldungWebinarGkFr",
      "WebformSubmissionAnmeldungWebinarMpaEBooksVe",
      "WebformSubmissionAnmeldungZumAbschiedsanlassVo",
      "WebformSubmissionBfsAnmeldungElternUndSupport",
      "WebformSubmissionBfsFageAnmeldungLehrbetriebe",
      "WebformSubmissionCwbAnmeldungDozierendentreffen",
      "WebformSubmissionDigitalesZulassungsverfahrenZo",
      "WebformSubmissionEMailTest",
      "WebformSubmissionEinverstaendniserklaerungVerlag",
      "WebformSubmissionEinverstaendniserklaerungVerwen",
      "WebformSubmissionEntity",
      "WebformSubmissionFeedbackLehrmittel",
      "WebformSubmissionFeedbackLehrmittelEnglisch",
      "WebformSubmissionFeedbackLehrmittelFranzoesisch",
      "WebformSubmissionFeedbackLehrmittelIt",
      "WebformSubmissionFeedbackMaengelWebsite",
      "WebformSubmissionFremdbeurteilungHfBma",
      "WebformSubmissionFremdbeurteilungHfMtr",
      "WebformSubmissionFremdbeurteilungHfOt",
      "WebformSubmissionHfBmaAnmeldungPraktikumsbetri",
      "WebformSubmissionHfDhAnmeldungPraktikumsbetrie",
      "WebformSubmissionHfDhBedarfsabklaerungFuerPra",
      "WebformSubmissionHfMtrAnmeldungPraktikumsbetri",
      "WebformSubmissionHfOtAnmeldungPraktikumsbetrie",
      "WebformSubmissionHfPflegeAnmeldungPraktikumsbe",
      "WebformSubmissionHoehereFachschuleBetriebePod",
      "WebformSubmissionInfotagGesundheit2022",
      "WebformSubmissionKiInDerBerufsbildung",
      "WebformSubmissionKontaktanfrageAuditorium",
      "WebformSubmissionKontaktformularCareumVerlag",
      "WebformSubmissionKontaktformularPruefgruppeLeic",
      "WebformSubmissionKontaktformularVerlag",
      "WebformSubmissionKontaktformularVerlagEn",
      "WebformSubmissionKontaktformularVerlagFr",
      "WebformSubmissionKontaktformularVerlagIt",
      "WebformSubmissionKundendaten",
      "WebformSubmissionLernberatungMitSicherheitImP",
      "WebformSubmissionMarketingmaterial",
      "WebformSubmissionNeuerZusatztitelProfessionalB",
      "WebformSubmissionNewsletterAnmeldungCapitoVerl",
      "WebformSubmissionNewsletterAnmeldungSphere",
      "WebformSubmissionNewsletterCareumVerlagSphere",
      "WebformSubmissionNewsletterCareumWeiterbildung",
      "WebformSubmissionNewsletterVerlag",
      "WebformSubmissionNewsletterVerlagSphereFr",
      "WebformSubmissionNewsletterVerlagSphereIt",
      "WebformSubmissionPruefungssituationErfolgreichM",
      "WebformSubmissionSprechstundenInteressierteBetr",
      "WebformSubmissionSprechstundenPraktikumsbetriebe",
      "WebformSubmissionStandardFormular",
      "WebformSubmissionTestFormular",
      "WebformSubmissionTestSeline",
      "WebformSubmissionWebinarProfessionelleGesundhei"
    ]
  }
};
      export default result;
    